import React from 'react';
import { motion } from 'framer-motion';

const Section = ({
  id,
  title,
  subtitle,
  description,
  children,
  className = "",
  background = "white",
  titleIcon,
  centered = true
}) => {
  const backgroundClasses = {
    white: "bg-white",
    slate: "bg-slate-50",
    dark: "bg-slate-900",
    gradient: "bg-gradient-to-br from-slate-900 via-slate-800 to-orange-900"
  };

  const textColor = background === "dark" ? "text-white" : "text-slate-900";
  const subtitleColor = background === "dark" ? "text-slate-300" : "text-slate-600";

  return (
    <section id={id} className={`py-24 ${backgroundClasses[background]} ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {(title || subtitle || description) && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className={centered ? "text-center mb-16" : "mb-16"}
          >
            {title && (
              <h2 className={`text-4xl md:text-6xl font-bold mb-6 ${textColor}`}>
                {titleIcon && <span className="mr-3">{titleIcon}</span>}
                {title}
              </h2>
            )}
            
            {subtitle && (
              <p className={`text-xl ${subtitleColor} max-w-3xl ${centered ? 'mx-auto' : ''} mb-6`}>
                {subtitle}
              </p>
            )}
            
            {description && (
              <p className={`text-lg ${subtitleColor} max-w-4xl ${centered ? 'mx-auto' : ''} leading-relaxed`}>
                {description}
              </p>
            )}
          </motion.div>
        )}
        
        {children}
      </div>
    </section>
  );
};

export default Section;